import React from "react"
import { StockDirectionPlaceholderProps } from "../../common/types/inventory"
import { INVENTORY_STOCK_DIRECTION } from "../../utils/inventory"
import { FormattedMessage } from "react-intl"

export const StockDirectionPlaceholder = (props: StockDirectionPlaceholderProps) => {

    switch (props.direction) {
    case INVENTORY_STOCK_DIRECTION.IN:
        return <FormattedMessage
            id="inventory.components.stock_direction_placeholder.in"
            defaultMessage="IN"
        />
    case INVENTORY_STOCK_DIRECTION.OUT:
        return <FormattedMessage
            id="inventory.components.stock_direction_placeholder.out"
            defaultMessage="OUT"
        />
    case INVENTORY_STOCK_DIRECTION.IN_OUT:
        return <FormattedMessage
            id="inventory.components.stock_direction_placeholder.in_out"
            defaultMessage="IN/OUT"
        />
    default:
        return <></>
    }

}


// WEBPACK FOOTER //
// ./src/inventory/components/StockDirectionPlaceholder.tsx